import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  installClickCurtain,
  installPreviewNavigateCurtain,
  registerCurtain,
} from '@/components/feature/routeCurtain';

export default function RouteCurtain() {
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    registerCurtain(ref.current);
    installPreviewNavigateCurtain();
    return () => registerCurtain(null);
  }, []);

  useEffect(() => {
    installClickCurtain((to) => navigate(to));
  }, [navigate]);

  return (
    <div
      ref={ref}
      aria-hidden="true"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#DDD6CC] text-foreground-950"
      style={{ visibility: 'hidden', pointerEvents: 'none', clipPath: 'inset(0% 100% 0% 0%)' }}
    >
      <span className="font-heading font-bold tracking-[-0.04em] text-xl">MATERA</span>
    </div>
  );
}